"use client"

import dynamic from "next/dynamic";
import { init } from "@dash0/sdk-web";
import { recorder } from "@dash0/sdk-web/session-recording";
import { useLoggedIn } from "@/helpers/isLoggedIn"

const Dash0WithClerk = dynamic(() => import("./Dash0WithClerk"));
import { useEffect } from "react";

export default function Dash0() {
    useEffect(() => {
        init({
            serviceName: "dash0.com - website",
            serviceVersion: process.env.VERCEL_GIT_COMMIT_SHA,
            environment: process.env.VERCEL_ENV,
            ignoreUrls: [
                // Anything related to PostHog must be ignored, to avoid circular tracing.
                /ph-ingest/i,
                // Google Analytics calls fail frequently due to ad blocking
                /g\/collect/i,
            ],
            endpoint: [{
                url: "https://eum-forwarder.eu-west-1.aws.dash0.com",
                authToken: "auth_d9cXsJAJW8trTjLClxVvLUzNB5hlddkl",
            }],
            // This is mainly to have some more test data
            headersToCapture: [/content-type/, /^x-/],
            sessionRecording: { recorder },
        });
    }, []);

    const loggedIn = useLoggedIn();

    // If the user is not logged in, there is no need to get user details from clerk
    if (!loggedIn) {
        return <></>;
    }

    return <Dash0WithClerk/>;
}
